import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterLink, RouterOutlet } from '@angular/router';
import { Subscription, filter, startWith } from 'rxjs';
import { DemoEntry } from '../demos/demos.model';
import { DemoCodeViewerComponent } from '../demo-code/demo-code-viewer.component';

/** Шелл страницы примера: заголовок/описание из data активного роута + живой пример + исходники. */
@Component({
  selector: 'app-demo-layout',
  standalone: true,
  imports: [CommonModule, RouterOutlet, RouterLink, DemoCodeViewerComponent],
  template: `
    <div class="demo-page">
      <a routerLink="/" class="demo-back">← All demos</a>
      <h1 class="demo-title">{{ demo?.title }}</h1>
      <p class="demo-desc" *ngIf="demo?.description">{{ demo?.description }}</p>
      <hr class="demo-rule">
      <router-outlet></router-outlet>
      <app-demo-code *ngIf="demo" [sources]="demo.sources"></app-demo-code>
    </div>
  `,
  styles: [`
    .demo-page { max-width: 1060px; margin: 0 auto; padding: 18px 24px 48px; }
    .demo-back { display: inline-block; margin: 6px 0 14px; text-decoration: none; color: var(--accent); font-weight: 500; }
    .demo-back:hover { text-decoration: underline; }
    .demo-title { margin: 0 0 6px; font-size: 26px; letter-spacing: -.3px; color: var(--text); }
    .demo-desc { margin: 0 0 14px; color: var(--text-soft); }
    .demo-rule { border: 0; border-top: 1px solid var(--card-border); margin: 0 0 18px; }
  `],
})
export class DemoLayoutComponent {
  demo?: DemoEntry;
  private sub: Subscription;

  constructor(router: Router, route: ActivatedRoute) {
    this.sub = router.events.pipe(
      filter(e => e instanceof NavigationEnd),
      startWith(null),
    ).subscribe(() => {
      let r = route;
      while (r.firstChild) r = r.firstChild;
      // На первом (startWith(null)) срабатывании конструктор может выполняться ДО того,
      // как роутер продвинул snapshot дочернего роута (activation ещё не завершена) —
      // r.snapshot в этот момент undefined. Пропускаем: корректный NavigationEnd придёт следом.
      if (!r.snapshot) return;
      this.demo = r.snapshot.data['demo'] as DemoEntry | undefined;
    });
  }

  ngOnDestroy(): void { this.sub.unsubscribe(); }
}
